import * as React from "react";
import { graphql, type HeadFC } from "gatsby";
import Layout from "../components/Layout/Layout";
import { Hero } from "../components/molecules/Hero";
import { Who } from "../components/molecules/WhoWeAre";
import { Proud } from "../components/molecules/Proud";
import { Programs } from "../components/molecules/Programs";
import { Testimonials } from "../components/molecules/Testimonials";
import { Orange } from "../components/molecules/Orange";
import { NewsLetter } from "../components/molecules/NewsLetter";
import { Container, Image, Text } from "@chakra-ui/react";
import { Slides } from "../components/molecules/Slides/Slides";

import { SEO } from "../components/Layout/Seo";

import homeXs from "../images/Home-375.webp";
import homeSm from "../images/Home-480.webp";
import homeMd from "../images/Home-768.webp";
import homeLg from "../images/Home-992.webp";
import homeXl from "../images/Home-1280.webp";
import home2Xl from "../images/Home-1536.webp";
import home3Xl from "../images/Home-1920.webp";

const IndexPage = ({ data }: any) => {
  const {
    wpPage: {
      home: {
        heroTitle,
        heroSubtitle,
        wwaTitle,
        wwaText,
        readMore,
        wwdTitle,
        statisticHomeRepeater: {},
        slidesRepeater: {},
        wpsaTitle,
        testimonialsRepeater: {},
        bannerTitle,
        bannerBtn,
      },
    },
  } = data;

  return (
    <>
      <Layout>
        <Hero
          title={heroTitle}
          subtitle={heroSubtitle}
          imageSrc={{
            base: `url(${homeXs})`,
            sm: `url(${homeSm})`,
            md: `url(${homeMd})`,
            lg: `url(${homeLg})`,
            xl: `url(${homeXl})`,
            "2xl": `url(${home2Xl})`,
            "3xl": `url(${home3Xl})`,
          }}
        />
        <Container maxW="7xl" px={0} mt={{ base: 10, md: 20 }}>
          <Image
            src={data.wpPage.home.bannerImg?.sourceUrl}
            width="100%"
            height="100%"
          />
        </Container>
        <Who
          title={wwaTitle}
          text={wwaText}
          // btn={readMore.title}
          link={readMore.url}
        />
        <Proud />
        <Programs title={wwdTitle} />
        <Slides slidesRepeater={data?.wpPage?.home?.slidesRepeater} />
        {/* <Pledge
          title={birminghamTitle}
          text={birminghamText}
          btn={birminghamBtn.title}
          link={birminghamBtn.url}
        /> */}
        <Testimonials
          title={wpsaTitle}
          testimonialsRepeater={data.wpPage.home.testimonialsRepeater}
        />
        <Orange
          className="bold"
          bg="#E6C188"
          href={bannerBtn.url}
          text={
            <Text textAlign="center" fontWeight="700" lineHeight="115%">
              {bannerTitle}
            </Text>
          }
          textColor="white"
          buttonText={bannerBtn.title}
          buttonColor="#D9A542"
        />

        <NewsLetter
          heading={"Add Impact to your inbox"}
          input={true}
          buttonText={"Sign Up"}
        />
      </Layout>
    </>
  );
};

export const query = graphql`
  {
    wpPage(id: { eq: "cG9zdDoyNTY=" }) {
      home {
        heroTitle
        heroSubtitle
        bannerImg {
          sourceUrl
        }
        wwaTitle
        wwaText
        readMore {
          title
          url
        }
        statisticHomeRepeater {
          homeNumber
          homeTitle
        }
        wwdTitle
        programsRepeater {
          programTitle
          programText
        }
        slidesRepeater {
          boxTitle
          boxText
          mainTitle {
            sourceUrl
          }
          mainImg {
            sourceUrl
          }
        }
        birminghamTitle
        birminghamText
        birminghamBtn {
          title
          url
        }
        wpsaTitle
        testimonialsRepeater {
          testimonialQuote
          testimonialTitle
          testimonialSubtitle
        }
        bannerTitle
        bannerBtn {
          title
          url
        }
      }
    }
  }
`;

export default IndexPage;

export const Head = () => (
  <SEO
    title="Global Ties Alabama"
    description="GLOBALIZING ALABAMA, ONE HANDSHAKE AT A TIME"
  />
);
